<template>
  <div class="third-box">
    <template v-if="subscription">
      <template v-if="nextPeriod">
        <Grid gaf="column" justify-content="space-between" class="text-secondary-1">
          <div class="text-heading-5 text-uppercase">
            {{ nextPeriod.one_time_purchase ? 'One time purchase' : 'Next period' }}
          </div>

          <div class="text-body-3" :class="{ 'text-grey3': nextPeriod.status.name === 'cancelled' }">
            {{ dateToDisplay }}
          </div>
        </Grid>

        <LineSeparator horizontal />

        <CancelledPeriod v-if="nextPeriod.status.name === 'cancelled'" class="q-pt-sm" @click="undoCancel" />
        <NextPeriodBox v-else-if="nextPeriod" />
      </template>

      <NoNextPeriodBox v-else />
    </template>

    <div v-else>Loading</div>
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
// Components
import NoNextPeriodBox from './NoNextPeriodBox'
import NextPeriodBox from './NextPeriodBox'
import CancelledPeriod from '../CancelledPeriod'
import LineSeparator from '@/modules/show-page-subscription/components/LineSeparator'

export default {
  components: {
    NoNextPeriodBox,
    NextPeriodBox,
    CancelledPeriod,
    LineSeparator
  },

  computed: {
    ...mapGetters('subscription-show', ['subscription']),

    nextPeriod() {
      return this.subscription?.next
    },

    dateToDisplay() {
      if (!this.nextPeriod) return

      const start = moment(this.nextPeriod.start_date).format('D. MMM YYYY')

      if (this.nextPeriod.one_time_purchase) return start

      let end = 'One time purchase'

      if (!this.nextPeriod.one_time_purchase) {
        end = this.nextPeriod.end_date !== null ? moment(this.nextPeriod.end_date).format('D. MMM YYYY') : 'N/A'
      }

      return `${start} - ${end}`
    }
  },

  methods: {
    ...mapMutations('subscription-show', ['setSubscription', 'updatePeriod']),

    undoCancel() {
      const periodId = this.nextPeriod.id

      apiTo.MODIFY_SUBSCRIPTION_PERIOD(periodId, { cancel: false }).then(({ data }) => {
        this.updatePeriod(data.result)
        apiTo.GET_SUBSCRIPTION(this.subscription.id).then(({ data }) => this.setSubscription(data.result))
        this.$root.$emit('refresh-workflow', { task: 'decisions' })
        this.$root.$emit('refresh-milestones-data', {
          periodId,
          milestone: 'decisions'
        })
      })
    }
  }
}
</script>
